export default {
  crashCoursePaymentList: state => state.crashCoursePaymentList,
  crashCourseList: state => state.crashCourseList
}
